import { render, staticRenderFns } from "./RegistrationErrorModule.vue?vue&type=template&id=6254ff67&scoped=true&"
import script from "./RegistrationErrorModule.vue?vue&type=script&lang=js&"
export * from "./RegistrationErrorModule.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationErrorModule.vue?vue&type=style&index=0&id=6254ff67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254ff67",
  null
  
)

export default component.exports